import { createTheme } from '@mui/material';

import { components } from './components';
import { distances } from './distances';
import { darkPalette, lightPalette } from './palette';
import { heritagePalette } from './palette/heritage';
import { sizes } from './sizes';
import { fontFamily, typography } from './typography';

const lightTheme = createTheme({
  palette: heritagePalette,
  typography,
  components,
  sizes,
  distances,
});

const darkTheme = createTheme({
  palette: heritagePalette,
  typography,
  components,
  sizes,
  distances,
});

export { darkTheme, fontFamily, lightTheme };
